<template>
  <v-row class="pa-4" no-gutters>
    <input
      ref="file-input"
      accept="image/jpeg"
      hidden="hidden"
      type="file"
      @change="change"
    />

    <v-col v-if="!activeState" class="pa-2 text-center" cols="12">
      <v-card-title class="justify-center">افزودن تصویر محصول</v-card-title>
      <v-card-subtitle>
        برای شروع یک عکس از محصول خود وارد نمایید.
      </v-card-subtitle>

      <v-card
        id="uploader"
        ref="uploader"
        :disabled="loading"
        :loading="loading"
        class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
        height="200"
        max-width="700"
        outlined
        @click="dragEvent"
        @dragleave="dragEvent"
        @dragover="dragEvent"
        @drop="dragEvent"
      >
        <v-icon size="68" style="opacity: 0.4"
          >mdi-cloud-upload-outline
        </v-icon>
        <v-card-title class="justify-center">آپلود فایل </v-card-title>
        <v-card-text class="text-center pt-0">
          برای آپلود بکشید و رها کنید یا
          <v-btn class="mx-1" color="primary" min-width="75" small>
            اینجا
          </v-btn>
          کلیک کنید
        </v-card-text>
      </v-card>
    </v-col>

    <v-col v-show="activeState" class="pa-2" cols="12">
      <custom-tabs v-model="panel" grow>
        <template v-slot:staticTabs>
          <v-tab
            v-for="(item, i) in tabItems"
            :key="item.value"
            :disabled="item.disabled"
            :tab-value="item.value"
          >
            <div class="cornel-left" />
            <div class="cornel-right" />
            <v-icon right>mdi-{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-tab>
        </template>
      </custom-tabs>
    </v-col>

    <v-col
      v-if="activeState"
      class="pa-2"
      cols="12"
      lg="4"
      md="6"
      order="2"
      order-md="1"
      xl="3"
    >
      <v-card
        class="rounded-lg overflow-y-auto overflow-x-hidden"
        height="75vh"
        max-height="75vh"
        outlined
      >
        <component
          :is="
            panel === 'createShot'
              ? 'VScrollXTransition'
              : 'VScrollXReverseTransition'
          "
          mode="out-in"
        >
          <div v-if="panel === 'createShot'" key="createShot">
            <div class="upload-wrapper" @click="$refs['file-input'].click()">
              <v-avatar color="rgba(0, 0, 0, .2)" size="98">
                <v-img
                  :src="imageSrc"
                  alt=""
                  class="rounded-0"
                  contain
                  max-height="50"
                  max-width="50"
                />
              </v-avatar>

              <v-btn :loading="loading" color="primary" depressed>
                انتخاب تصویر
              </v-btn>
            </div>
          </div>

          <template v-for="(item, i) in designComponents">
            <component
              :is="item.component"
              v-if="panel === item.key"
              :key="item.key"
              v-model="obj[item.key]"
              @back="panel = 'createShot'"
              @change="changeEvent"
            />
          </template>
        </component>
      </v-card>
    </v-col>

    <v-col
      v-show="activeState"
      class="pa-2"
      cols="12"
      lg="8"
      md="6"
      order="1"
      order-md="2"
      style="max-height: 75vh; overflow: hidden"
      xl="9"
    >
      <div
        id="canvas-wrapper"
        :style="{ paddingBottom: obj.aspectRatio }"
        style="position: relative; width: 100%"
      >
        <canvas
          id="canvas"
          style="
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            max-height: 75vh;
          "
        ></canvas>
      </div>
      <div id="loadingOverlay">
        <v-progress-circular class="mb-2" indeterminate size="35" width="5" />
        <span>درحال به‌روزرسانی تصویر...</span>
      </div>
    </v-col>

    <v-col v-if="activeState" class="pa-2" cols="12" order="3">
      <v-card-actions class="pa-0 flex-wrap justify-end">
        <v-btn
          class="px-4 white--text rounded-lg"
          color="primary"
          depressed
          @click="downloadImage"
        >
          <v-icon left>mdi-download</v-icon>
          دانلود تصویر
        </v-btn>

        <v-btn
          :loading="loading"
          class="px-4 rounded-lg white--text"
          color="green"
          depressed
          @click="saveImage"
        >
          <v-icon left>mdi-content-save</v-icon>
          ذخیره
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import DesignBgSelect from "@/components/designImage/designBgSelect.vue";
import DesignCanvasRatio from "@/components/designImage/DesignCanvasRatio.vue";
import {
  VScrollXReverseTransition,
  VScrollXTransition,
} from "vuetify/lib/components";
import { DesignImage } from "@/utilities/designImage";
import { CanvasHandler } from "@/utilities/designImageCanvas";

let canvasHandler = null;

export default {
  name: "designImage",

  components: {
    DesignBgSelect,
    DesignCanvasRatio,
    VScrollXReverseTransition,
    VScrollXTransition,
  },

  data: () => ({
    loading: false,
    imageSrc: "/media/img/designImage/photo-add.svg",
    activeState: false,
    panel: "createShot", // 'background', 'outline', 'shadow', 'effect', 'aspectRatio'
    tabItems: [
      {
        value: "createShot",
        text: "تغییر تصویر",
        icon: "image-edit-outline",
        disabled: false,
      },
      {
        value: "background",
        text: "پیش زمینه",
        icon: "image-outline",
        disabled: false,
      },
      {
        value: "aspectRatio",
        text: "ابعاد تصویر",
        icon: "resize",
        disabled: false,
      },
      {
        value: "outline",
        text: "حاشیه",
        icon: "border-outside",
        disabled: true,
      },
      { value: "shadow", text: "سایه", icon: "box-shadow", disabled: true },
      {
        value: "effect",
        text: "جلوه‌ها",
        icon: "vector-point-plus",
        disabled: true,
      },
    ],
    obj: {
      background: {
        type: "image" /* 'image', 'color', 'gradient' */,
        image: "",
        color: "#D81A1AFF",
        gradient: "",
      },
      aspectRatio: "56.25%",
    },
    designComponents: [
      { key: "background", component: "DesignBgSelect" },
      { key: "aspectRatio", component: "DesignCanvasRatio" },
      { key: "outline", component: "DesignBgSelect" },
      { key: "shadow", component: "DesignBgSelect" },
      { key: "effect", component: "DesignBgSelect" },
    ],
    base64String: "",
  }),

  mounted() {
    setTimeout(() => {
      canvasHandler = new CanvasHandler("canvas");
      canvasHandler.setBackground(
        this.$cdnUrl + "/aiProduct/6562179d73bcdad8151492c6/path.png"
      );
      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => canvasHandler.resizeCanvas(), 350);
      });
    }, 2000);
  },

  methods: {
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;
      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        this.change(e);
      } else if (e.type === "click") {
        this.$refs["file-input"].click();
      }
    },
    change(e) {
      this.loading = true;
      const design = new DesignImage(
        e.target?.files?.[0] || e.dataTransfer?.files?.[0]
      );

      design
        .removeBg()
        .then(({ data }) => {
          this.imageSrc = `data:image/png;base64,${data.data.base64}`;

          if (!this.activeState) {
            this.activeState = true;
            this.$nextTick(() => {
              setTimeout(() => canvasHandler.resizeCanvas(), 300);
            });
          }

          this.panel = "background";

          // ساخت یه تصویر موقت برای اطمینان از لود کامل قبل از set
          const tempImg = new Image();
          tempImg.src = data.data.link;
          tempImg.onload = () => {
            canvasHandler.loadImage(data.data.link);
          };
          tempImg.onerror = () => {
            this.$toast.error("مشکل در بارگذاری تصویر!");
          };
        })
        .catch(() => {
          this.$toast.error("خطا در پردازش تصویر");
        })
        .finally(() => (this.loading = false));
    },

    changeEvent(e) {
      if (e === "bg") {
        switch (this.obj.background.type) {
          case "image":
            canvasHandler.setBackground(this.obj.background.image);
            break;
          case "color":
            canvasHandler.setBackgroundColor(this.obj.background.color);
            break;
          case "gradient":
            canvasHandler.setBackgroundGradient(
              "linear",
              this.obj.background.gradient.colors
            );
        }
      } else if (e === "ratio") {
        console.log("e: ", e, this.obj.aspectRatio);
        setTimeout(() => canvasHandler.resizeCanvas(), 350);
      }
    },
    downloadImage() {
      canvasHandler.downloadImage();
    },
    saveImage() {
      this.loading = true;

      canvasHandler
        .saveImage()
        .then((data) => {
          this.$toast.success("تصویر با موفقیت آپلود شد ");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.imported-images {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 16px;
}

.upload-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 2px dashed rgba(0, 0, 0, 0.1);
  transition: all 0.1s ease-in-out;
  cursor: pointer;
  padding: 16px 24px;
  margin: 16px;
  border-radius: 8px;

  &:hover {
    border-style: solid;
    background-color: rgba(100, 100, 100, 0.05);
  }
}

#canvas-wrapper {
  height: 0;
}

#loadingOverlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
  font-size: 18px;
  color: var(--v-primary-base);
  display: none;
}

#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #797979 !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}
</style>
